module.exports = __webpack_public_path__ + "media/plastic_2.512d5771.webm";